import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  return (
    <header className="header">
      <NavLink
        to="/"
        className="w-10 h-10 rounded-lg bg-white items-center justify-center flex font-bold shadow-md"
      >
        <p className="blue-gradient_text">AS</p>
      </NavLink>
      <nav className="flex text-lg gap-5 font-medium">
        <div className="hidden md:block">
          <div className="flex text-lg gap-5 font-medium">
            <NavLink
              to="/about"
              className={({ isActive }) =>
                isActive ? "text-blue-500" : "nav-text"
              }
            >
              About
            </NavLink>
            <NavLink
              to="/projects"
              className={({ isActive }) =>
                isActive ? "text-blue-500" : "nav-text"
              }
            >
              Projects
            </NavLink>
            <NavLink
              to="/contact"
              className={({ isActive }) =>
                isActive ? "text-blue-500" : "nav-text"
              }
            >
              Contact
            </NavLink>
            <NavLink
              to="https://drive.google.com/file/d/1miG9-v1tcS-1OBe0jBU7ywjTQabqImJ_/view?usp=drive_link"
              target="_blank"
              className={({ isActive }) =>
                isActive ? "text-blue-500" : "nav-text"
              }
            >
              Resume
            </NavLink>
          </div>
        </div>
        {/* Mobile menu, show/hide based on menu state. */}
        {isOpen && (
          <div className="md:hidden" id="mobile-menu">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 flex flex-col">
              <NavLink
                to="/about"
                className={({ isActive }) =>
                  isActive ? "text-blue-500" : "nav-text"
                }
              >
                About
              </NavLink>
              <NavLink
                to="/projects"
                className={({ isActive }) =>
                  isActive ? "text-blue-500" : "nav-text"
                }
              >
                Projects
              </NavLink>
              <NavLink
                to="/contact"
                className={({ isActive }) =>
                  isActive ? "text-blue-500" : "nav-text"
                }
              >
                Contact
              </NavLink>
              <NavLink
                to="https://drive.google.com/file/d/1sf4iFfH2BuhnClDu-w4lfLKxAW_TBkrn/view?usp=sharing"
                target="_blank"
                className={({ isActive }) =>
                  isActive ? "text-blue-500" : "nav-text"
                }
              >
                Resume
              </NavLink>
              {/* Add more links as needed */}
            </div>
          </div>
        )}

        <div className="-mr-2 flex md:hidden">
          <button
            onClick={toggleMenu}
            type="button"
            className="bg-gray-800 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
          >
            <span className="sr-only">Open main menu</span>
            {!isOpen ? (
              <svg
                className="block h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                ></path>
              </svg>
            ) : (
              <svg
                className="block h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            )}
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
